import {call, put, takeEvery} from "redux-saga/effects";
import Api from "../services/Api";

function* fetchJourneyComment(params) {
  try {
    const journeyComment = yield call(function() {
      return Api.get(`/journey/comment/${params.uuid}`)
    });
    yield put({type: 'FETCH.JOURNEY_COMMENT.SUCCESS', journeyComment});
  } catch (error) {
    yield put({type: 'FETCH.JOURNEY_COMMENT.FAILURE', error});
  }
}
function* deleteJourneyAttachment(params) {
  try {
    const journeyComment = yield call(function() {
      return Api.delete(`/journey/comment/${params.uuid}?key=${params.key}`)
    });
    yield put({type: 'DELETE.JOURNEY_COMMENT.SUCCESS', journeyComment});
  } catch (error) {
    yield put({type: 'DELETE.JOURNEY_COMMENT.FAILURE', error});
  }
}

export function* watchJourneyComment() {
  yield takeEvery('FETCH.JOURNEY_COMMENT.REQUEST', fetchJourneyComment);
  yield takeEvery('DELETE.JOURNEY_COMMENT.REQUEST', deleteJourneyAttachment);
}

